import { usePartnersStore } from "@nextories/vue-tasks/src/store/partnersStore";
import { useUsersStore } from "@nextories/vue-tasks/src/store/usersStore";
import { useAuthStore } from "@nextories/vue-tasks/src/store/authStore";
import filterHelper from '@nextories/vue-tasks/src/utils/helpers/common/filter';
import projectsHelper from '@nextories/vue-tasks/src/utils/helpers/projects';
import moversHelper from '@nextories/vue-tasks/src/utils/helpers/movers';
import { i18n } from "@/plugins/i18n";
import type { Filter, FilterQuery } from "@nextories/vue-tasks/src/types/Filters";

export const pluginProjectsStore = {
  actions: {
    setInitialFilters(query?: FilterQuery) {
      const mainFilters = this.baseMainFilters;
      const partnerAccount = usePartnersStore().$state.listPartnerAccount;
      const filterUsers = useUsersStore().$state.filterUsers;
      const currentUser = useAuthStore().$state.currentUser;
      const filterUsersN2 = useUsersStore().$state.filterUsersN2;
      let myTasks = null;
      // Only modify myTasks if needed
      if (filterUsersN2.myTasks) {
        this.queryDefault.myTasks = true;
        myTasks = {
          ...filterUsersN2.myTasks,
          title: i18n.global.t('base.myProjects'), // No need for deep copy
        };
      }
      // Set base filters
      this.setBaseMainFilters(query);
      // Remove filter for non-admin users
      if (currentUser && !currentUser.is_admin) {
        delete filterUsers.not_assigned_user;
      }
      // Status filter setup
      mainFilters.status = {
        ...mainFilters.status,
        refKeys: {
          assigned_user_id: ['assigned_n2_user_id'],
        },
        subFilters: {
          ...this.createSubFilters(filterUsersN2, myTasks, query, partnerAccount),
        },
      };
      // Apply the main filters in the correct order
      this.setMainFilters(filterHelper.setOrderMainFilters(mainFilters));
    },
    // Helper function to generate subFilters efficiently
    createSubFilters(filterUsersN2: Filter[], myTasks: Filter, query?: FilterQuery, partnerAccount?: Filter[]) {
      return {
        ...filterUsersN2,
        ...filterHelper.setSubFilterEnabled('status', myTasks, query),
        ...projectsHelper.formatStatusFilter(),
        ...filterHelper.setSubFiltersEnabled('status', this.statusDefault, projectsHelper.formatStatusFilter()),
        ...(partnerAccount?.length ? projectsHelper.formatPartnerAccountFilter(partnerAccount) : {}),
        ...moversHelper.moversFilter({ notEdit: true }),
        ...filterHelper.formatDatesFilter('loadingDate', 'final_dep_date'),
        ...filterHelper.formatDatesFilter('deliveryDate', 'final_arr_date'),
        ...projectsHelper.nbTasksFilter(),
        ...projectsHelper.formatDisputeFilter(),
      };
    }
  },
};

